export function pageGrey (user) {
  return new Promise((resolve,reject) => {
      const res = user.get('/api/office/userLogin/isGrey')
      resolve(res.data)
  })
}